import React from 'react';
import { generateModifierClasses } from "../../modules/utils";
export default function TabsLink({ children, className, href = '#', modifiers, onClick, value }) { let classes = generateModifierClasses('tabs__link', modifiers); if (className) {
    classes += ` ${className}`;
} return /*#__PURE__*/ React.createElement("a", { className: classes, href: href, onClick: onClick, "data-value": value }, children); }
